/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "../../MaterialKit/MKBox";
import MKTypography from "../../MaterialKit/MKTypography";

import overdueLogoSvg from "../../../assets/images/logos/logo-overdue.svg";

function DefaultFooter({socials, menus}) {

  return (
    <MKBox component="footer">
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3} sx={{ ml: "auto", mb: 0, textAlign: "center" }}>
            <MKBox component="img" maxWidth="8rem" src={overdueLogoSvg} alt="Overdue Logo" width="100%" />
            <MKBox mt={3}>
              {socials.map(({ icon, link }, key) => (
                <MKTypography
                  key={link}
                  component="a"
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                  variant="h5"
                  color="dark"
                  opacity={0.8}
                  mr={key === socials.length - 1 ? 0 : 2.5}
                >
                  {icon}
                </MKTypography>
              ))}
            </MKBox>
          </Grid>
          {menus.map(({ name: title, route, items }) => (
            <Grid key={title} item xs={6} md={2} sx={{ mb: 3 }}>
              <MKTypography
                component={route ? Link : ""}
                display="block"
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
                to={route}
                mb={1}
              >
                {title}
              </MKTypography>
              {items && <MKBox component="ul" p={0} m={0} sx={{ listStyle: "none" }}>
                {items.map(({ name, route, href }) => (
                  <MKBox key={name} component="li" p={0} m={0} lineHeight={1.25}>
                    {href ? (
                      <MKTypography
                        component="a"
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        variant="button"
                        fontWeight="regular"
                        textTransform="capitalize"
                      >
                        {name}
                      </MKTypography>
                    ) : (
                      <MKTypography
                        component={Link}
                        to={route}
                        variant="button"
                        fontWeight="regular"
                        textTransform="capitalize"
                      >
                        {name}
                      </MKTypography>
                    )}
                  </MKBox>
                ))}
              </MKBox>}
            </Grid>
          ))}
          <Grid item xs={12} sx={{ textAlign: "center", my: 3 }}>
            <MKTypography variant="button" fontWeight="regular">
              All rights reserved. Copyright &copy; {new Date().getFullYear()} Overdue.
            </MKTypography>
            <MKTypography variant="button" fontWeight="regular" display="block" mt={0.5}>
              We support{" "}
              <MKTypography
                component="a"
                href="https://oaths.co.za"
                target="_blank"
                rel="noreferrer"
                variant="button"
                fontWeight="bold"
              >
                Oaths.co.za
              </MKTypography>
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

// Typechecking props for the DefaultFooter
DefaultFooter.propTypes = {
  content: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.array]))
};

DefaultFooter.defaultProps = {
  socials: [
    { icon: <i className="fab fa-facebook" />, link: "https://www.facebook.com/fetchplease" },
    { icon: <i className="fab fa-x-twitter" />, link: "https://x.com/OverdueLegal" },
    {
      icon: <i className="fab fa-linkedin" />,
      link: "https://www.linkedin.com/company/84036423/admin",
    }
  ]
};

export default DefaultFooter;
